// Initialize the cart count on page load
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
});

// Function to update cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const count = cart.item_count;
      // Update all cart count elements on the page
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
      });
      // Update cart count in the header
      document.querySelector('.header-cart-count').textContent = count > 0 ? `BAG(${count})` : 'BAG';
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Function to add item to cart
function addToCart(variantId, quantity = 1) {
  // Show loading state if desired
  const addToCartButton = document.querySelector(`[data-variant-id="${variantId}"]`);
  if (addToCartButton) {
    addToCartButton.classList.add('loading');
  }

  // Add to cart using Shopify AJAX API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    // Update cart count immediately after successful add
    updateCartCount();
    
    // Remove loading state
    if (addToCartButton) {
      addToCartButton.classList.remove('loading');
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    if (addToCartButton) {
      addToCartButton.classList.remove('loading');
    }
  });
}